import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import {
  Input,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
} from '@material-ui/core'

import * as DeviceActionCreators from '../../../actions/device'
import CommandParamsDialog from './CommandParamsDialog'

const sampleCommand = {
  command: 'sample',
  params: {
    int: { type: 'int' },
    float: { type: 'float64' },
    bool: { type: 'bool' },
    string: { type: 'string' },
  },
}

class Sample extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired,
    isEditing: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    deviceActions: PropTypes.object.isRequired,
  }

  static mapDispatchToProps(dispatch) {
    return {
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
    }
  }

  static styles = () => ({
    root: {
      width: 'auto',
    },
  })

  state = { executingCommand: null }

  onRateChange = (ev) => {
    const val = parseInt(ev.currentTarget.value, 10)

    const config = {
      ...this.props.device.target_config,
      sample: {
        rate: Number.isNaN(val) ? undefined : val,
      },
    }
    this.props.onChange(config)
  }

  onShowCommandDialog = (command) => {
    this.setState({ executingCommand: command })
  }

  onCloseCommandDialog = () => {
    this.setState({ executingCommand: null })
  }

  onCommand = (command) => {
    this.props.deviceActions.executeCommand(this.props.device.id, command.command, command.params)
  }

  render() {
    const { classes, device, isEditing } = this.props
    const { executingCommand } = this.state

    const current = device.current_config
    const target = device.target_config

    return (
      <>
        <Table className={classes.root}>
          <TableHead>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Current</TableCell>
              <TableCell>Target</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Rate</TableCell>
              <TableCell>{current.sample.rate}</TableCell>
              <TableCell>
                <Input disabled={!isEditing} value={target.sample.rate} onChange={this.onRateChange} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Button
          onClick={() => this.onShowCommandDialog(sampleCommand)}
        >
          Command
        </Button>
        { executingCommand
          && (
            <CommandParamsDialog
              command={executingCommand}
              onExecute={this.onCommand}
              onClose={this.onCloseCommandDialog}
            />
          )}
      </>
    )
  }
}

export default connect(
  Sample.mapStateToProps,
  Sample.mapDispatchToProps,
)(withStyles(Sample.styles)(Sample))
